import { render, staticRenderFns } from "./cv-select-option.vue?vue&type=template&id=dd15acc8&"
import script from "./cv-select-option.vue?vue&type=script&lang=js&"
export * from "./cv-select-option.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports